
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.364 10.766v4.598h-4.598v-4.598h4.598zM13.832.804h2.299v1.533h1.15c.51 0 .957.191 1.34.574.383.384.575.83.575 1.341V17.28c0 .511-.192.958-.575 1.341-.383.383-.83.575-1.34.575H2.72c-.511 0-.958-.192-1.341-.575-.383-.383-.575-.83-.575-1.34V4.251c0-.51.192-.957.575-1.34.383-.384.83-.575 1.34-.575h1.15V.804h2.3v1.533h7.663V.804zM17.28 17.28V7.126H2.72V17.28h14.56z","fill":"#4788C6","fill-rule":"nonzero"}})])
          )
        }
      }
    